// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `apple-pay-button {
    --apple-pay-button-width: 100%;
    --apple-pay-button-height: 50px;
    --apple-pay-button-border-radius: 3px;
    --apple-pay-button-padding: 5px 0px;
    --apple-pay-button-box-sizing: border-box;
}

`, "",{"version":3,"sources":["webpack://./src/modules/HPP/controls/apple-pay/apple-pay.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,qCAAqC;IACrC,mCAAmC;IACnC,yCAAyC;AAC7C","sourcesContent":["apple-pay-button {\n    --apple-pay-button-width: 100%;\n    --apple-pay-button-height: 50px;\n    --apple-pay-button-border-radius: 3px;\n    --apple-pay-button-padding: 5px 0px;\n    --apple-pay-button-box-sizing: border-box;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
